import React from 'react';
import { Outlet } from 'react-router-dom';
import { Flex } from '@chakra-ui/react';

const Main = () => {
  return (
    <Flex
      minH={'100vh'}
      align={'center'}
      justify={'center'}
      bgGradient="linear(primary, primaryDark)"
    >
      <Outlet />
    </Flex>
  );
};

export default Main;
